const getInitialState = () => ({
    tables: {},
});

export default {
    getInitialState
};
